export default {
  category: 'account',
  actions: {
    create: 'create',
    login: 'login',
    verify: 'verify',
    show: 'show',
    dismiss: 'dismiss',
    click: 'click',
    allow: 'allow',
    deny: 'deny',
  },
  labels: {
    email: 'email',
    facebook: 'facebook',
    google: 'google',
    apple: 'apple',
    signIn: 'signin',
    signUp: 'signup',
    verify: 'verify',
    partner: 'partner',
    confirmation: 'confirmation',
    linkAlexa: 'linkAlexa',
  },
};
